import DecoderWorker from "worker-loader!./Decoder.worker.ts";

export { DecoderWorker };



// WEBPACK FOOTER //
// ./src/web-workers/index.ts